import {
  ALIGN_BOTTOM_BETWEEN_OBJECTS_LINE_ID,
  ALIGN_LEFT_BETWEEN_OBJECTS_LINE_ID,
  ALIGN_RIGHT_BETWEEN_OBJECTS_LINE_ID,
  ALIGN_TOP_BETWEEN_OBJECTS_LINE_ID,
  H_LINE_ID, HORIZONTAL_LINE_OF_INTERSECT_IN_CENTER_OF_OBJECTS,
  V_LINE_ID, VERTICAL_LINE_OF_INTERSECT_IN_CENTER_OF_OBJECTS
} from "@/common/preview/positioning-lines";
import { ShowPageScopeCollector } from '@frontend/group/modules/scope-collectors/show-page-collector';
import { makeEditableV2EventBroker, EVENTS } from './event-broker';
import { FIELD_TYPE_BACKGROND_THEME_IMAGE } from "@frontend/constants/type-fields-of-template";
import { DEFAULT_BACKGROUND_THEME_IMAGE_FIELD_PROPERTIES } from '@frontend/group/modules/additional-fields'

const NOT_PROCESSED_OBJECTS = [
  'pixel_background',
  H_LINE_ID,
  V_LINE_ID,
  ALIGN_TOP_BETWEEN_OBJECTS_LINE_ID,
  ALIGN_BOTTOM_BETWEEN_OBJECTS_LINE_ID,
  ALIGN_LEFT_BETWEEN_OBJECTS_LINE_ID,
  VERTICAL_LINE_OF_INTERSECT_IN_CENTER_OF_OBJECTS,
  HORIZONTAL_LINE_OF_INTERSECT_IN_CENTER_OF_OBJECTS,
  ALIGN_RIGHT_BETWEEN_OBJECTS_LINE_ID,
];

const getShowPageScope = () => ShowPageScopeCollector.get([
  'previews',
]);

const getObjectsForOrder = (objects) => objects
  .filter(object => !NOT_PROCESSED_OBJECTS.includes(object.id))
  .map(object => {
    if (object.get('type') === 'group') {
      const groupObjects = object.getObjects();
      return {
        name: 'Group',
        isGroup: true,
        target: object,
        id: object.id,
        visible: false,
        objects: getObjectsForOrder(groupObjects),
      }
    }

    return {
      name: object?.templateField?.name || object?.name,
      target: object,
      objects: [],
      id: object.id,
    }
  });

const handlerButton = (instanceId) => {
  const { previews } = getShowPageScope();

  const currentPreview = previews.find(preview => preview.id == instanceId);

  if (!currentPreview) {
    return false;
  }
  
  const allBackgroundImages = [];
  
  previews.forEach(preview => {
    const objects = getObjectsForOrder(preview.canvas.getObjects());
    
    objects.forEach(object => {
      let thumbnail = null;
      let url = null;
      
      if (object.target._element) {
        let _url = new URL(object.target._element.currentSrc);
        url = _url.toString();

        _url.searchParams.set('lightweight', '');
        _url.searchParams.set('scale_width', '30');
        thumbnail = _url.toString();
      }
    
      const type = object.target.templateField?.type || FIELD_TYPE_BACKGROND_THEME_IMAGE;
      const finalUrl = url || DEFAULT_BACKGROUND_THEME_IMAGE_FIELD_PROPERTIES.additional_background_images;
      
      if (type === FIELD_TYPE_BACKGROND_THEME_IMAGE && finalUrl !== DEFAULT_BACKGROUND_THEME_IMAGE_FIELD_PROPERTIES.additional_background_images) {
          const templateName = preview.template?.name || 'Template';
          allBackgroundImages.push({
              id: object.target.id,
              name: object.name || 'Image',
              templateName,
              type: type,
              thumbnail: thumbnail || DEFAULT_BACKGROUND_THEME_IMAGE_FIELD_PROPERTIES.additional_background_images,
              url: finalUrl,
              target: object.target,
              instanceId: preview.id,
              preview: preview
          });
      }
    });
  });
  
  makeEditableV2EventBroker.fire(EVENTS.INIT, {
    allBackgroundImages,
    clickedInstanceId: instanceId,
    preview: currentPreview,
  });
}

export function initMakeEditableV2Handler($row) {
  const $button = $row.find('.make-editable-v2');

  $button.off('click').on('click', function () {
    const id = $(this).attr('data-id');
    handlerButton(id);
  });
}
